<template>
  <el-popover placement="left"
              width="480"
              trigger="click">
    <el-table border
              :data="row.stepPrices">
      <el-table-column label="数量区间"
                       min-width="180">
        <template slot-scope="{ row  }">{{ row.minNum }}万枚（含）-{{ row.maxNum }}万枚（不含）</template>
      </el-table-column>
      <el-table-column label="采购单价"
                       min-width="100"
                       prop="unitPrice">
        <template slot-scope="{ row  }">{{ row.unitPrice }}元/枚</template>
      </el-table-column>
      <el-table-column label="其他费用"
                       min-width="110"
                       prop="otherFees">
        <template slot-scope="{ row  }">
          <div v-for="(item, index) in row.otherFees"
               :key="index">{{ item.feeName }}：{{ item.fee }}元</div>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="text" style="margin-left: 10px"
               slot="reference">查看采购价</el-button>
  </el-popover>
</template>

<script>
export default {
  name: 'purchase-product-price-popover',
  props: {
    row: { type: Object, default: () => {} }
  }
}
</script>
